<template>
    <div class="header-dropdown-box"
        @mouseenter="handleEnter"
        @mouseleave="handleLeave">
        <!-- 标题 -->
        <router-link :to="routerLink"
            :class="['header-dropdown-title',{'active-dropdown':isEnter}]">
            <slot name="title"></slot>
            <span v-if="totalMsg.totalNum">（{{totalMsg.totalNum}}）</span>
            <span v-else>（0）</span>
        </router-link>
        <div class="header-dropdown-list-box"
            v-show="isEnter">
            <!-- 未登录 -->
            <template v-if="!isLogin">
                <div class="go-login">
                    <slot name="goLogin"></slot>
                </div>
            </template>
            <!-- 登录 & 无参数 -->
            <template v-else-if="isLogin && !listData || !listData.length">
                <div class="nothing">
                    <slot name="nothing"></slot>
                </div>
            </template>
            <!-- 登录 & 有参数 -->
            <template v-else>
                <!-- 商品列表 -->
                <el-scrollbar
                    tag="ul"
                    :native="false"
                    class="header-dropdown-list">
                    <!-- 商品列表 -->
                    <li v-for="(item,index) in listData" 
                        :key="index">
                        <!-- 删除按钮 -->
                        <el-button
                            type="text"
                            size="mini"
                            @click="handleDel(item)"
                            class="header-dropdown-list-del-btn">
                            <i class="el-icon-circle-close"></i>
                        </el-button>
                        <!-- 图片 -->
                        <router-link 
                            :to="{name: 'pdetail', query:{id: item.goods_id},params:{cate_id:item.cat_id}}" 
                            class="header-dropdown-list-img">
                            <img :src="item.goods_images[0]" alt="">
                        </router-link>
                        <!-- 详情内容 -->
                        <div class="header-dropdown-list-detail">
                            <!-- 商品标题 -->
                            <router-link 
                                :to="{name: 'pdetail', query:{id: item.goods_id},params:{cate_id:item.cat_id}}"
                                class="header-dropdown-list-detail-title">
                                {{item.goods_name}}
                            </router-link>
                            <!-- 价格 & 计数器 -->
                            <el-row>
                                <el-col :span="12" v-if="showPrice">
                                    <div class="header-dropdown-list-detail-price">
                                        <span>{{currency}}</span>
                                        <span>{{item.goods_price}}</span>
                                    </div>
                                </el-col>
                                <el-col :span="12" :offset="showPrice?0:12">
                                    <el-input-number
                                        size="mini"
                                        :value="item.goods_number"
                                        :min="1"
                                        :max="item.rec_id? item.goodsnum: NaN"
                                        @change="handleNum($event,item)"
                                        class="header-dropdown-list-detail-num">
                                    </el-input-number>
                                </el-col>
                            </el-row>
                        </div>
                    </li>
                </el-scrollbar>
                <!-- 结算 -->
                <div class="header-dropdown-total">
                    <el-row>
                        <el-col :span="15">
                            <!-- 数量统计 -->
                            <div>{{$t('message.header.totalNum', { num: totalMsg.totalNum })}}</div>
                            <!-- 价格统计 -->
                            <div class="header-dropdown-total-price"
                                v-if="showPrice">
                                <span>{{$t("message.header.total")+currency}}</span>
                                <span>{{totalMsg.totalPrice}}</span>
                            </div>
                        </el-col>
                        <el-col :span="9">
                            <el-button
                                type="primary"
                                @click="handleJump"
                                class="header-dropdown-total-btn">
                                <slot name="total_btn"></slot>
                            </el-button>
                        </el-col>
                    </el-row>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
    data() {
        return {
            // 鼠标是否移入
            isEnter: false,
        }
    },
    computed:{ 
        ...mapState({
            currency: state => state.currency,
            isLogin: state => state.user.islogin
        }),
        ...mapGetters([
            'powerPrice',
        ]),
        // 判断是否显示价格
        showPrice() {
            return this.powerPrice && this.routerLink !== '/center/quoteCart';
        },
        totalMsg(){
            let totalNum = 0, totalPrice = 0;
            for(let item of this.listData){
                totalNum += Number(item.goods_number);
                // 只有在显示价格时才计算总价
                if(this.showPrice) {
                    totalPrice += Number(item.goods_number) * Number(item.goods_price)
                }
            }
            return { totalNum, totalPrice: totalPrice.toFixed(2) }
        }
    },
    props: {
        "router-link": {
            type: String,
            default: ''
        },
        "list-data": {
            type: null,
            default: () => []
        },
        "handleDel": {
            type: null
        },
        "handleNum": {
            type: null
        },
        "handleJump": {
            type: null
        },
    },
    methods: {
        // 鼠标移入事件
        handleEnter(){
            this.isEnter = true;
        },
        // 鼠标移出事件
        handleLeave(){
            this.isEnter = false;
        },
    },
}
</script>

<style scoped>
/* 下拉菜单盒子 */
.header-dropdown-box{
    position: relative;
    display: inline-block;
    margin-left: 1px;
}

/* 下拉菜单标题 */
.header-dropdown-title{
    display: block;
    padding: 0 15px;
    color: #fff;
    background-color: #424242;
}
.header-dropdown-box>.active-dropdown{
    color: #FF6700;
    background-color: #fff;
}

/* 下拉菜单盒子 */
.header-dropdown-list-box{
    position: absolute;
    top: 50px;
    right: 0;
    line-height: normal;
    color: #333;
    z-index: 500;
    box-shadow: -2px 2px 5px #eee;
    transition: all .5s linear;
}
/* 列表盒子 */
.header-dropdown-list{
    width: 300px;
    /* min-height: 125px; */
    max-height: 500px;
    /* padding-bottom: 60px; */
    background-color: #fff;
    /* overflow-y: scroll; */
}
.header-dropdown-list li{
    height: 55px;
    padding: 0 5px 5px 5px;
    margin-top: 15px;
    border-bottom: 1px solid #EBEEF5;
}
.header-dropdown-list>>>.el-scrollbar__wrap{
    max-height: 500px;
}
/* 商品图片 */
.header-dropdown-list-img{
    position: relative;
    display: inline-block;
    vertical-align: middle;
    width: 50px;
    height: 50px;
    margin: 0 10px;
    border: 1px solid #eee;
    overflow: hidden;
}
.header-dropdown-list-img>img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    max-width: 100%;
    max-height: 100%;
}
/* 详细内容盒子 */
.header-dropdown-list-detail{
    display: inline-block;
    vertical-align: middle;
    width: 200px;
    height: 100%;
    text-align: center;
}
/* 商品标题 */
.header-dropdown-list-detail-title{
    display: block;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 3px;
}
/* 价格 */
.header-dropdown-list-detail-price{
    text-align: left;
}
.header-dropdown-list-detail-price>span{
    display: inline-block;
    vertical-align: middle;
    font-size: 10px;
}
.header-dropdown-list-detail-price>span:first-child{
    margin-right: 5px;
}
.header-dropdown-list-detail-price>span:last-child{
    color: #FF6700;
}
/* 计数器 */
.header-dropdown-list-detail-num{
    width: 100%;
}

/* 统计区域 */
.header-dropdown-list-box>.header-dropdown-total{
    width: 100%;
    height: 60px;
    padding: 10px;
    background-color: #E4E7ED;
    z-index: 1000;
}
/* 价格统计 */
.header-dropdown-total-price>span:last-child{
    margin-left: 5px;
    color: #FF6700
}
/* 结算区域按钮 */
.header-dropdown-total-btn{
    width: 100%;
    height: 100%;
}

/* 未登录显示内容 */
.nothing,
.go-login{
    width: 300px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    background-color: #fff;
}
.go-login>a{
    margin-left: 5px;
    color: #FF6700;
    font-size: 16px;
    font-weight: bold;
}
</style>
